import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import "../styles/cricket99.css";

const Cricbet99Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className="cricbet99-page">
      <Helmet>
        <title>Reddy Anna - Cricbet99 Betting ID Cricket Betting India</title>
        <meta
          name="description"
          content="Get Cricbet99 betting ID from Reddy Anna for cricket betting in India with live access and fast login."
        />
        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org",
 "@type": "WebPage",
 "name": "Reddy Anna - Cricbet99 Betting ID Cricket Betting India",
 "url": "https://reddyannaaid.com/cricbet99",
 "description": "Get Cricbet99 betting ID from Reddy Anna for cricket betting in India with live access and fast login."
}

          `}
        </script>
      </Helmet>
      <div className="header">
        <h1>
          Welcome to <span className="highlight">Cricbet99</span>: Your Premier
          Betting Hub
        </h1>
        <img src="/cricbet99logo.webp" alt="Cricbet99 Logo" className="logo" />
      </div>

      <section className="cricbet99-intro">
        <p>
          Experience the next level of sports betting with{" "}
          <span className="highlight">Cricbet99</span>, powered by{" "}
          <span className="highlight">Reddy Anna</span>. Whether you’re
          passionate about cricket or looking for a diverse range of betting
          opportunities, Cricbet99 has everything you need to make every bet
          count.
        </p>
        <div className="cricbet99-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Create Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get In Touch with Us
          </a>
        </div>
      </section>

      <section className="cricbet99-why-choose">
        <h2>
          Why Choose <span className="highlight">Cricbet99</span>?
        </h2>
        <ol>
          <li>
            <strong>Comprehensive Betting Options:</strong> With Cricbet99,
            explore a vast array of sports betting, online casino games, and
            more, tailored to your preferences by{" "}
            <span className="highlight">Reddy Anna</span>.
          </li>
          <li>
            <strong>Dynamic 99 Exchange:</strong> Dive into real-time betting
            with our unique 99 Exchange platform, where you can place bets
            against other users and track your own success.
          </li>
          <li>
            <strong>Guaranteed Transaction Security:</strong> Bet with peace of
            mind through secure payment methods, ensuring that your deposits and
            withdrawals are hassle-free and protected.
          </li>
          <li>
            <strong>24/7 Support Team:</strong> Have questions or need
            assistance? Our dedicated support team, led by{" "}
            <span className="highlight">Reddy Anna</span>, is available
            round-the-clock to guide you through your betting experience.
          </li>
        </ol>
        <div className="cricbet99-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Create Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get In Touch with Us
          </a>
        </div>
      </section>

      <section className="cricbet99-features">
        <h2>
          Features that Make <span className="highlight">Cricbet99</span> Stand
          Out
        </h2>
        <ol>
          <li>
            <strong>Exclusive Betting Platform:</strong> Immerse yourself in the
            exciting world of cricket betting with Cricbet99, where every match
            offers you a chance to win big.
          </li>
          <li>
            <strong>State-of-the-Art Technology:</strong> Benefit from our
            advanced platform, designed for seamless betting and a flawless user
            experience every time you log in.
          </li>
          <li>
            <strong>Innovative 99 Exchange:</strong> Take your betting
            experience to new heights by engaging with others in real-time
            through our one-of-a-kind 99 Exchange, giving you more control over
            your bets.
          </li>
        </ol>
      </section>

      <section className="cricbet99-getting-started">
        <h2>
          Getting Started with <span className="highlight">Cricbet99</span>
        </h2>
        <ol>
          <li>
            <strong>Register with Reddy Anna:</strong> Head to our website,
            register, and get your Cricbet99 ID easily through Reddy Anna.
          </li>
          <li>
            <strong>Explore Our Betting Opportunities:</strong> Browse through
            an expansive range of betting options, from exciting cricket matches
            to other sports and casino games.
          </li>
          <li>
            <strong>Place Your Bets and Enjoy:</strong> Once registered, start
            placing your bets and follow your favorite teams and events as they
            unfold in real-time.
          </li>
        </ol>
        <div className="cricbet99-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Create Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get In Touch with Us
          </a>
        </div>
      </section>

      <section className="cricbet99-security">
        <h2>
          Safety and Security at <span className="highlight">Cricbet99</span>
        </h2>
        <p>
          At Cricbet99, we prioritize your security and ensure that every
          transaction you make is completely safe. With cutting-edge encryption
          and secure systems in place, you can enjoy your betting experience
          without worries.
        </p>
        <p>
          Join Cricbet99 today and embark on an exciting journey with endless
          betting opportunities. Bet confidently, win big, and experience the
          thrill of the game at Cricbet99 – your ultimate betting destination!
        </p>
        <div className="cricbet99-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Create Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get In Touch with Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default Cricbet99Page;
